<template>
  <div class="filter-wrapper">
    <div class="filter-header">
      <h2>Reported Problems </h2>
      <h3 v-if="totals.problems !== 0">
        Showing {{ totals.problems }} problem reports in {{ totals.schools }} schools
      </h3>
    </div>
    <div class="filter-toggle-header">
      <button class="btn sml secondary filter-toggle" @click="hideFilters = !hideFilters">{{ hideFilters ? 'Open' : 'Close' }}</button>
      <h3>Filters: </h3>
    </div>
    <div :class="{ filters: true, closed: hideFilters, withSorts: sorts}">
      <div v-for="filter in filters" v-bind:key="filter['.name']" class="filter">
        <h4>{{ filter.shortLabel }}</h4>
        <v-select multiple placeholder="All" :options="filter.values" label="shortLabel" v-model="selectedFilters[filter.name]" @input="filtersChanged"></v-select>
      </div>
      <div v-if="sorts" class="sorts">
        <h4>Sort By:</h4>
      <v-select :options="sorts" v-model="selectedSort" @input="sortChanged"></v-select>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { distanceInWordsToNow, parse, format, differenceInDays } from 'date-fns'
  export default {
    name: 'ProblemFilters',
    components: {
      vSelect
    },
    props: {
      totals: Object,
      filters: Array,
      selectedFilters: Object,
      sorts: Array,
    },
    data() {
      return {
        selectedSort: null,
        hideFilters: true
      }
    },
    mounted () {
      if (this.sorts) {
        this.selectedSort = this.sorts[0]
      }
    },
    methods: {
      filtersChanged() {
        this.$emit('filtersChanged', this.selectedFilters)
      },
      sortChanged () {
        if (this.selectedSort) {
          this.$emit('sortChanged', this.selectedSort.key)
        }
      },
      dateWords (date) {
        const daysAgo = differenceInDays(date, new Date())
        // console.log(daysAgo)
        var time = format(date, 'dddd, MMMM D, YYYY')
        return time + ' (' + distanceInWordsToNow(date, false) + ')'
      }
    }
  }
</script>

<style scoped>

.filter-wrapper {
  margin: 0 25px 13px;
}

.filter-wrapper h2 {
  margin: 0 0 8px;
}
.filter-wrapper h3 {
  margin: 0 0 9px;
}
.filter-wrapper h4 {
  margin: 0 0 5px;
}
/* .filters {
  margin: 0 0 13px;
  display: flex;
  display: grid;
  grid-template-columns: 6;
  grid-template-rows: auto;
  grid-row-gap: .11%;
  grid-column-gap: 1%;
} */
.filter-toggle-header{
  border-top: 1px solid #ddd;
  padding: 10px 0 0;
}

.filter-toggle-header::after {
  content: "";
  clear: both;
  display: table;
}
.filter-toggle {
  float: right;
  margin-left: 15px;
}
.filters.closed {
  display: none;
}
.filters .sorts,
.filters .filter {
  margin-bottom: 10px;
}

@media only screen and (min-width: 680px) {    
.filter-toggle-header {
    display:none;
}
  .filter-header {
    position: relative;
    margin-right: 144px;
  }
  .filters.closed,
  .filters {
    margin: 0 0 13px;
    display: flex;
  }
  .filters .sorts,
  .filters .filter {
    float: left;
    width: 17%;
  }
}
.filters .filter .dropdown {
  margin-right: 10px;
}


/* .filters.withSorts {
  grid-template-columns: 16% 17% 17% 17% 17% 16%;
} */
</style>